// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'name',
    title: '名称',
    visible: true,
    width: '150',
    fixed: 'left',
  },
  {
    field: 'pinyin',
    title: '拼音',
    visible: true,
  },
  {
    field: 'productCategoryName',
    title: '商品分类',
    visible: true,
    width: 220,
  },
  {
    field: 'productChName',
    title: '商品名称',
    visible: true,
    width: 220,
  },
  {
    field: 'attrStatus',
    title: '状态',
    visible: true,
    width: 220,
  },
  {
    field: 'companyName',
    title: '公司',
    visible: true,
    width: '150',
  },
  {
    field: 'departmentName',
    title: '部门',
    visible: true,
  },
];

// 搜索栏
export const formColumn = () => {
  return [
    // {
    //   prop: 'companyCode',
    //   name: '公司',
    //   type: 'select',
    //   options: ctx.companyList,
    //   changeMethod: 'changeMethod',
    //   isHidden: ctx.attrType == '04',
    // },
    // {
    //   prop: 'departmentCode',
    //   name: '部门',
    //   type: 'select',
    //   options: ctx.departmentList,
    //   changeMethod: 'changeMethod',
    //   isHidden: ctx.attrType == '04',
    // },
    {
      prop: 'name',
      name: '名称',
      type: 'input',
    },
  ];
};
